import { createElementBlock as c, openBlock as e, createElementVNode as l } from "vue";
import t from "./index289.js";
const o = {}, r = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function n(m, a, s, f, i, p) {
  return e(), c("svg", r, a[0] || (a[0] = [
    l("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      l("path", {
        fill: "#F7F6EF",
        d: "M36.292 28.804c-1.071 0-2.078.22-2.96.657-.66-4.321-4.44-7.64-8.973-7.64-4.944 0-8.974 3.945-9.1 8.83A6.008 6.008 0 0 0 10 36.632c0 3.318 2.708 6.012 6.046 6.012h20.246c3.842 0 6.959-3.1 6.959-6.92s-3.117-6.919-6.959-6.919Z"
      }),
      l("path", {
        fill: "#FFF3AB",
        d: "M27.307 17.13a7.522 7.522 0 0 1 5.4-2.292c4.217 0 7.636 3.503 7.636 7.824"
      }),
      l("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M24.359 20.572c4.542 0 8.475 2.945 9.827 7.092l.044.143.225-.055c.471-.105.96-.169 1.46-.19l.377-.008c4.531 0 8.209 3.657 8.209 8.169 0 4.512-3.678 8.17-8.209 8.17H16.046c-4.026 0-7.296-3.251-7.296-7.262a7.258 7.258 0 0 1 5.18-6.973l.155-.044.014-.112c.67-4.952 4.874-8.789 9.975-8.927Zm0 2.5c-4.254 0-7.742 3.393-7.85 7.612a1.25 1.25 0 0 1-1.093 1.208 4.757 4.757 0 0 0-4.166 4.74c0 2.626 2.147 4.76 4.796 4.76h20.246c3.153 0 5.709-2.541 5.709-5.67 0-3.127-2.555-5.668-5.709-5.668-.89 0-1.706.18-2.404.527a1.25 1.25 0 0 1-1.79-.93c-.575-3.753-3.865-6.58-7.74-6.58Zm8.349-9.484c4.913 0 8.885 4.07 8.885 9.074a1.25 1.25 0 0 1-2.5 0c0-3.637-2.866-6.574-6.385-6.574a6.27 6.27 0 0 0-4.506 1.916 1.25 1.25 0 1 1-1.79-1.746 8.77 8.77 0 0 1 6.296-2.67ZM21.046 10.69a1.25 1.25 0 0 1 1.767.037l1.07 1.115.088.104a1.25 1.25 0 0 1-1.893 1.626l-1.07-1.114-.088-.104a1.25 1.25 0 0 1 .126-1.664Zm21.651-.056a1.25 1.25 0 0 1 1.705 1.824l-1.069 1.114-.1.094a1.25 1.25 0 0 1-1.704-1.824l1.069-1.115Zm-26.893 37.14a1.25 1.25 0 0 1 2.297.979l-.05.118-1.848 3.785a1.25 1.25 0 0 1-2.297-.978l.05-.118 1.848-3.786Zm14.778 0a1.25 1.25 0 0 1 2.297.979l-.05.118-1.848 3.785a1.25 1.25 0 0 1-2.297-.978l.05-.118 1.848-3.786Zm-7.39 1.893a1.25 1.25 0 0 1 2.298.979l-.05.117-1.848 3.786a1.25 1.25 0 0 1-2.297-.978l.05-.118 1.848-3.786Zm13.855 0a1.25 1.25 0 0 1 2.297.979l-.05.117-.923 1.893a1.25 1.25 0 0 1-2.298-.978l.05-.118.924-1.893ZM32.715 5.764a1.25 1.25 0 0 0-1.243 1.123l-.007.127V8.58a1.25 1.25 0 0 0 2.494.128l.006-.128V7.014c0-.69-.56-1.25-1.25-1.25ZM46.46 21.412a1.25 1.25 0 0 0-.128 2.494l.128.006h1.527a1.25 1.25 0 0 0 .128-2.493l-.128-.007h-1.527Z"
      })
    ], -1)
  ]));
}
const h = /* @__PURE__ */ t(o, [["render", n]]);
export {
  h as default
};
